import { defineStore } from 'pinia'
import { ref } from 'vue'
import { persistPiniaSlice, loadPiniaSlice } from '../persist'

export const useTestResultStore = defineStore('testResult', () => {
    const startTime = ref(undefined)
    const endTime = ref(undefined)
    const cancelled = ref(true)
    const expectedDurationInSeconds = ref(undefined)
    const savedToBackend = ref(false)

    const persist = () => {
        persistPiniaSlice('testResultStore', {
            startTime: startTime.value,
            endTime: endTime.value,
            cancelled: cancelled.value,
            expectedDurationInSeconds: expectedDurationInSeconds.value,
            testResultsSavedToBackend: savedToBackend.value,
        })
    }

    const resetTestResults = () => {
        startTime.value = undefined
        endTime.value = undefined
        cancelled.value = false
        expectedDurationInSeconds.value = undefined
        savedToBackend.value = false
        persist()
    }

    const setStartTime = (time) => {
        if (!startTime.value && time) startTime.value = time
        else
            console.warn(
                'Test Start Time already set or specified value is not a date!'
            )
    }

    const setEndTime = (time) => {
        if (time) endTime.value = time
        else console.warn('End time needs to be a date!')
    }

    const setExpectedDuration = (durationInSeconds) => {
        if (durationInSeconds && durationInSeconds > 0) {
            expectedDurationInSeconds.value = durationInSeconds
            persist()
        }
    }

    const initTestState = ({ startTime: time, expectedDurationInSeconds: duration }) => {
        resetTestResults()
        setStartTime(time)
        setExpectedDuration(duration)
        persist()
    }

    const finalizeTestState = ({ isCancelled, endTime: time }) => {
        if (isCancelled) cancelled.value = true
        setEndTime(time)
        persist()
    }

    const testResultsSavedToBackend = () => {
        savedToBackend.value = true
        persist()
    }

    const loadFromLocalStorage = () => {
        const slice = loadPiniaSlice('testResultStore')
        if (!slice) return
        if (slice.startTime !== undefined) {
            startTime.value = slice.startTime
        }
        if (slice.endTime !== undefined) {
            endTime.value = slice.endTime
        }
        if (typeof slice.cancelled === 'boolean') {
            cancelled.value = slice.cancelled
        }
        if (slice.expectedDurationInSeconds !== undefined) {
            expectedDurationInSeconds.value = slice.expectedDurationInSeconds
        }
        if (typeof slice.testResultsSavedToBackend === 'boolean') {
            savedToBackend.value = slice.testResultsSavedToBackend
        }
    }

    loadFromLocalStorage()

    return {
        startTime,
        endTime,
        cancelled,
        expectedDurationInSeconds,
        savedToBackend,

        initTestState,
        finalizeTestState,
        resetTestResults,
        testResultsSavedToBackend,
        setExpectedDuration,
    }
})
